import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IMyMonitoringUserModel } from '@apps-common/types/portal/users'

export const updateMyMonitoringUser = async (model: IMyMonitoringUserModel): Promise<boolean> =>
  axios.post(`/my-monitoring/sites/UpdateMyMonitoringUser`, model).then((res) => res?.data?.result)

type Props = {
  model: IMyMonitoringUserModel
}

export const useMyMonitoringUpdateMyMonitoringUser = (
  notify?: boolean,
  onSuccess?: (data: boolean) => void,
  successMsg?: string,
  errorMsg?: string
) =>
  useMutation({
    mutationKey: ['updateMyMonitoringUser'],
    mutationFn: ({ model }: Props) => updateMyMonitoringUser(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess(successMsg || 'User updated.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(errorMsg || error?.message || 'Failed to update user.')
      }
    },
    throwOnError: false
  })
